export default function SvgChange() {
  return (
    <svg
      width="23"
      height="13"
      viewBox="0 0 21 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0687 3.75C10.3512 1.71125 8.40875 0.25 6.125 0.25C3.22875 0.25 0.875 2.60375 0.875 5.5C0.875 8.39625 3.22875 10.75 6.125 10.75C8.40875 10.75 10.3512 9.28875 11.0687 7.25H14.875V10.75H18.375V7.25H20.125V3.75H11.0687ZM6.125 7.25C5.1625 7.25 4.375 6.4625 4.375 5.5C4.375 4.5375 5.1625 3.75 6.125 3.75C7.0875 3.75 7.875 4.5375 7.875 5.5C7.875 6.4625 7.0875 7.25 6.125 7.25Z"
        fill="white"
      />
    </svg>
  );
}
